/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import { isNil } from 'lodash';
import { LineSegmentProps, LineSegment } from 'victory';
import appTheme from '../../../common/theme/appTheme.json';

interface LineAnnotationProps extends LineSegmentProps {
  length: number;
  x?: number;
  y?: number;
}

const LineAnnotation = (props: LineAnnotationProps) => {
  // flyoutComponent passes x, y and cursorComponent passes x1,y1,x2,y2
  const { length, x, y, x1, y1, x2, y2 } = props;
  const vertDisplacement = 27;

  return (
    <React.Fragment>
      <LineSegment
        {...props}
        x1={!isNil(x) ? x : x1}
        y1={!isNil(y) ? y : y1}
        x2={!isNil(x) ? x : x1}
        y2={(!isNil(y) && y + length) || (!isNil(y1) && y1 + length) || 0}
        style={{ stroke: appTheme.primaryTextColor, strokeWidth: 2 }}
        transform={isNil(x2) && isNil(y2) ? `translate(0,${vertDisplacement})` : ''}
      />
    </React.Fragment>
  );
};

export default LineAnnotation;
